var _rect, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 17,
    width: 10,
    height: 10,
    fill: "#FEBA08"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 17,
    width: 10,
    height: 10,
    fill: "#05A6F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 5,
    width: 10,
    height: 10,
    fill: "#80BC06"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 10,
    height: 10,
    fill: "#F25325"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoft);
export default __webpack_public_path__ + "static/media/microsoft.e1a689ba93422208cbb44f7dc1895139.svg";
export { ForwardRef as ReactComponent };